import React, { useState, useEffect } from 'react'
import coordinatorStyle from './CoordinatorDashbaordPage.module.css'
import SideBar from '../../components/SideBar/SideBar'
import CoordinatorHeader from '../../components/Header/CoordinatorHeader'
import CoordinatorPageBar from '../../components/CoordinatorPageBar/CoordinatorPageBar'
import CoordinatorMobilPageBar from '../../components/CoordinatorMobilPageBar/CoordinatorMobilPageBar'
import AddEventPage from "../../pages/addevent/AddEventPage"
import { LuPencilLine } from "react-icons/lu";
import { FaShareSquare } from "react-icons/fa";
import { FaCirclePlus } from "react-icons/fa6";
import { IoMdSearch } from "react-icons/io";
import { Link, useNavigate } from 'react-router-dom';
import TopBars from '../../components/topbars/TopBars'
import { useMediaQuery } from 'react-responsive';
import { FaTrashAlt } from "react-icons/fa";
import Swal from "sweetalert2";

export default function CoordinatorDashboardPage() {

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });


  const [events, setEvents] = useState([]);  // To store fetched events
  const [loading, setLoading] = useState(true); // To show loading message
  const [error, setError] = useState(null);  // To store error message in case of failure
  const [statusFilter, setStatusFilter] = useState("all");
  const [recordLimit, setRecordLimit] = useState(0);
  const navigate = useNavigate();
  const cordinatorID = localStorage.getItem('cordinator_id');
  const filteredEvents = events.filter(event => {
    if (statusFilter === "all") return true;
    return event.status.toLowerCase() === statusFilter;
  });


  const limitedEvents = recordLimit > 0
    ? filteredEvents.slice(0, recordLimit)
    : filteredEvents;
  // const cordinatorFName = localStorage.getItem('coordinatorFName');
  // const cordinatorLName = localStorage.getItem('coordinatorLName');
  // const cordinatorPosition = localStorage.getItem('coordinatorPosition');
  // const cordinatorPic = localStorage.getItem('coordinatorPic');
  // Fetching data when the component mounts
  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const coordinatorId = localStorage.getItem('cordinator_id');
        // Change the URL to your API endpoint
        // const response = await fetch('http://www.bookwormtest.com/authormeetapi/get_events.php');
        // const BASE_URL = process.env.REACT_APP_API_BASE_URL;
        // const response = await fetch(`${BASE_URL}get_events.php?coordinator_id=${coordinatorId}`);
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_events.php?coordinator_id=${coordinatorId}`);

        // Check if the response is OK
        if (!response.ok) {
          throw new Error('Failed to fetch events');
        }

        // Parse the JSON data
        const data = await response.json();
        // console.log("data" , data)

        // Check if the 'success' key is true and events are available
        if (data.success && Array.isArray(data.events)) {
          // Parse book_data for each event and add it to events
          const updatedEvents = data.events.map(event => {
            // Parse book_data from string to array
            const books = event.book_data ? JSON.parse(event.book_data) : [];

            // Ensure the books array is not empty and the author_name exists
            const authorName = books.length > 0 && books[0].authorName ? books[0].authorName : '-';

            // Add the books array and the safely fetched author_name to the event object
            return { ...event, books, authorName };

          });

          setEvents(updatedEvents); // Set the updated events data to state
        }
        else if (!(data.success)) {
          navigate('/dashboard');
        }
        else {
          throw new Error('Invalid events data');
        }

        // Set the events data to state
        // setEvents(data.events);
      } catch (err) {
        setError(err.message); // If any error occurs
      } finally {
        setLoading(false);  // Set loading to false once the request is finished
      }
    };

    fetchEvents();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString || dateString === "0000-00-00 00:00:00") return "000";

    // Convert MySQL format to ISO-safe format
    const date = new Date(dateString.replace(" ", "T"));

    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  };

  const formatTime = (timeString) => {
    if (!timeString) return "";

    const [hourStr, minuteStr] = timeString.split(":");
    let hour = parseInt(hourStr, 10);
    const minutes = minuteStr;

    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12; // convert 0 → 12

    return `${hour}:${minutes} ${ampm}`;
  };


  const handleDeleteClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    Swal.fire({
      title: "Not Allowed",
      text: "Only admin can delete this event.",
      icon: "info",
      timer: 2500,
      showConfirmButton: false,
    });
  };

  // const handleDeleteEventFromDraft = (e , eventData) => {
  //   console.log("eventData :",eventData)
  //   e.preventDefault();
  //   e.stopPropagation();
  //   setEvents(events.filter(eventItem => eventItem.tbl_event_id !== eventData.tbl_event_id))
  // }

  const handleDeleteEventFromDraft = (e, eventData) => {
    e.preventDefault();
    e.stopPropagation();


    Swal.fire({
      title: "Are you sure?",
      text: `Do you really want to delete "${eventData.event_name}"?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        setEvents(events.filter(eventItem => eventItem.tbl_event_id !== eventData.tbl_event_id));

        Swal.fire({
          title: "Deleted!",
          text: `"${eventData.event_name}" has been deleted.`,
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });
      } else {
        console.log("User cancelled deletion");
      }
    });
  };

 const formatDateMMDDYYYY = (dateString) => {
        // console.log("dateString", dateString)
        if (!dateString || dateString === "0000-00-00 00:00:00") return "000";

        const date = new Date(dateString.replace(" ", "T"));

        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();

        return `${month}/${day}/${year}`;
    };



  return (
    <>
      <CoordinatorHeader />
      {isMobile ? (
        <div className={coordinatorStyle.addeventmobiltopbar}>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-12'>
                <CoordinatorMobilPageBar />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={coordinatorStyle.addeventdesktoptopbar}>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-12'>
                <CoordinatorPageBar />
              </div>
            </div>
          </div>
        </div>
      )}

      {isMobile ? (
        <div className={coordinatorStyle.coordidashboardmobilpage}>
          <div className='container'>
            <div className='row'>
              <div className='col-12'>
                {events.map((event) => (
                  <Link to={`/FullEventPage/${event.tbl_event_id}`}>
                    <div className={`${event.status.toLowerCase() === "approved" ? coordinatorStyle.mobilstatusWrap : event.status.toLowerCase() === "not approved" ? coordinatorStyle.mobilstatusWrap : event.status.toLowerCase() === "draft" ? coordinatorStyle.mobilstatusWrap : event.status.toLowerCase() === "waiting for approval" ? `${coordinatorStyle.mobilstatusWrap} ${coordinatorStyle.waitingBg}` : ""}`}>
                      <div className="d-flex justify-content-between align-items-start pb-2">
                        <div className='pe-3 w-75'>
                          <p className={`${coordinatorStyle.mainHeadings} ${event.status.toLowerCase() === "approved" ? `` : event.status.toLowerCase() === "not approved" ? `` : event.status.toLowerCase() === "draft" ? `` : event.status.toLowerCase() === "waiting for approval" ? coordinatorStyle.waitingtextColor : ""}`}> Event Name </p>
                          <p className={`${coordinatorStyle.maindataText} ${event.status.toLowerCase() === "approved" ? `` : event.status.toLowerCase() === "not approved" ? `` : event.status.toLowerCase() === "draft" ? `` : event.status.toLowerCase() === "waiting for approval" ? coordinatorStyle.waitingtextColor : ""}`}> {event.authorName} </p>
                        </div>
                        <div className='w-25 text-end d-flex align-items-end justify-content-end'>
                          <a href="#" className={coordinatorStyle.statusEdit}> Edit
                            <LuPencilLine className='ms-1' />
                          </a>
                        </div>
                      </div>
                      <div className={`${coordinatorStyle.whatStatus}`}>
                        <h6 className='d-flex justify-content-start align-items-center'>
                          <strong> Status: </strong>
                          <div className={`${event.status.toLowerCase() === "approved" ? coordinatorStyle.approvedDot : event.status.toLowerCase() === "not approved" ? coordinatorStyle.notApprovedDot : event.status.toLowerCase() === "draft" ? coordinatorStyle.draftDot : event.status.toLowerCase() === "waiting for approval" ? coordinatorStyle.waitingDot : ""} mx-2`}></div>
                          {event.status}
                        </h6>
                      </div>
                      <div className={`${coordinatorStyle.mobilstatusData} d-flex`}>
                        <div className="pe-3 w-50">
                          <p className={`${coordinatorStyle.mainHeadings} ${event.status.toLowerCase() === "approved" ? `` : event.status.toLowerCase() === "not approved" ? `` : event.status.toLowerCase() === "draft" ? `` : event.status.toLowerCase() === "waiting for approval" ? coordinatorStyle.waitingtextColor : ""}`}> Start and End Date </p>
                          <p className={`${coordinatorStyle.maindataText} ${event.status.toLowerCase() === "approved" ? `` : event.status.toLowerCase() === "not approved" ? `` : event.status.toLowerCase() === "draft" ? `` : event.status.toLowerCase() === "waiting for approval" ? coordinatorStyle.waitingtextColor : ""}`}> {event.event_start_date}-{event.event_end_date} </p>
                        </div>
                        <div className={`w-50 ${coordinatorStyle.lineBreak}`}>
                          <p className={`${coordinatorStyle.mainHeadings} ${event.status.toLowerCase() === "approved" ? `` : event.status.toLowerCase() === "not approved" ? `` : event.status.toLowerCase() === "draft" ? `` : event.status.toLowerCase() === "waiting for approval" ? coordinatorStyle.waitingtextColor : ""}`}> Event Details: </p>
                          <p className={`${coordinatorStyle.maindataText} ${event.status.toLowerCase() === "approved" ? `` : event.status.toLowerCase() === "not approved" ? `` : event.status.toLowerCase() === "draft" ? `` : event.status.toLowerCase() === "waiting for approval" ? coordinatorStyle.waitingtextColor : ""}`}> {event.event_detail} </p>
                        </div>
                      </div>
                      <div className={`${coordinatorStyle.mobilstatusData} d-flex pb-0`}>
                        <div className="pe-3 w-50">
                          <p className={`${coordinatorStyle.mainHeadings} ${event.status.toLowerCase() === "approved" ? `` : event.status.toLowerCase() === "not approved" ? `` : event.status.toLowerCase() === "draft" ? `` : event.status.toLowerCase() === "waiting for approval" ? coordinatorStyle.waitingtextColor : ""}`}> Location: </p>
                          <p className={`${coordinatorStyle.maindataText} ${event.status.toLowerCase() === "approved" ? `` : event.status.toLowerCase() === "not approved" ? `` : event.status.toLowerCase() === "draft" ? `` : event.status.toLowerCase() === "waiting for approval" ? coordinatorStyle.waitingtextColor : ""}`}> {event.event_location} </p>
                        </div>
                        <div className="w-50">
                          <p className={`${coordinatorStyle.mainHeadings} ${event.status.toLowerCase() === "approved" ? `` : event.status.toLowerCase() === "not approved" ? `` : event.status.toLowerCase() === "draft" ? `` : event.status.toLowerCase() === "waiting for approval" ? coordinatorStyle.waitingtextColor : ""}`}> Order books by: </p>
                          <p className={`${coordinatorStyle.maindataText} ${event.status.toLowerCase() === "approved" ? `` : event.status.toLowerCase() === "not approved" ? `` : event.status.toLowerCase() === "draft" ? `` : event.status.toLowerCase() === "waiting for approval" ? coordinatorStyle.waitingtextColor : ""}`}> {
                                                                        event?.event_order_date
                                                                            ? formatDateMMDDYYYY(event?.event_order_date)
                                                                            : "00/00/0000"
                                                                    } </p>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
                <button className={`${coordinatorStyle.mobiladdeventButton} btn btn-light w-100 mb-5`}>
                  <FaCirclePlus className={coordinatorStyle.mobilbtnIconplus} />
                  <Link to="/add-event" element={<AddEventPage />}>
                    Add an Event  </Link>
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={coordinatorStyle.coordidashboardDesktoppage}>
          <div className='container'>
            <div className='row'>
              <div className='col' style={{ maxWidth: '275px', position: 'sticky', top: '120px', height: '100vh' }}>
                <SideBar />
              </div>
              <div className="col">
                <div className={coordinatorStyle.statusBoxes}>
                  <div style={{ position: 'sticky', top: '120px', zIndex: 5, overflow: 'hidden' }}>
                    <TopBars total={filteredEvents.length} onStatusChange={(value) => setStatusFilter(value)} onRecordChange={(value) => setRecordLimit(value)} />
                  </div>

                  <div style={{ flex: 1, paddingTop: '1rem' }}>
                    <div className='row'>
                      {limitedEvents.map((event) => (
                        <div key={event.tbl_event_id} className='col-xl-4 col-sm-12 col-md-6'>
                          <Link to={`/FullEventPage/${event.tbl_event_id}`}>
                            <div className={`${event.status.toLowerCase() === "approved" ? coordinatorStyle.statusWrap : event.status.toLowerCase() === "not approved" ? coordinatorStyle.statusWrap : event.status.toLowerCase() === "draft" ? coordinatorStyle.statusWrap : event.status.toLowerCase() === "waiting for approval" ? `${coordinatorStyle.statusWrap} ${coordinatorStyle.waitingBg}` : ""}`}>
                              <div className="d-flex justify-content-between align-items-center pb-3">
                                <div className='w-50'>
                                  <h2 className={`${coordinatorStyle.statusTitle} ${event.status.toLowerCase() === "approved" ? `` : event.status.toLowerCase() === "not approved" ? `` : event.status.toLowerCase() === "draft" ? `` : event.status.toLowerCase() === "waiting for approval" ? coordinatorStyle.waitingtextColor : ""}`}> {event.event_name} {/*: {event.authorName} */} </h2>
                                </div>
                                {
                                  event.status.toLowerCase() === "draft" && (
                                    <div className='w-50 text-end d-flex align-items-end justify-content-end'>
                                      <a href="#" className={`${coordinatorStyle.statusEdit} text-primary`}> Edit
                                        <LuPencilLine className='ms-1 me-2 text-primary' />
                                      </a>
                                      {/* <a href="#" className={`${coordinatorStyle.statusEdit} text-danger`}> Delete
                                  <FaTrashAlt className='ms-1 text-danger' />
                                </a> */}

                                      <div onClick={(e) => handleDeleteEventFromDraft(e, event)} className={`${coordinatorStyle.statusEdit} text-danger`}> Delete
                                        <FaTrashAlt className='ms-1 text-danger' />
                                      </div>
                                    </div>
                                  )
                                }

                                {
                                  event.status.toLowerCase() === "waiting for approval" && (
                                    <div className='w-50 text-end d-flex align-items-end justify-content-end'>
                                      {/* <a href="#" className={`${coordinatorStyle.statusEdit} text-primary`}> Edit
                                  <LuPencilLine className='ms-1 me-2 text-primary' />
                                </a> */}
                                      <a onClick={(e) => handleDeleteClick(e)} className={`${coordinatorStyle.statusEdit} text-danger`}> Delete
                                        <FaTrashAlt className='ms-1 text-danger' />
                                      </a>
                                    </div>
                                  )
                                }
                              </div>
                              <div className={`${coordinatorStyle.whatStatus}`}>
                                <h6 className='d-flex justify-content-start align-items-center'>
                                  <strong> Status: </strong>
                                  <div className={`${event.status.toLowerCase() === "approved" ? coordinatorStyle.approvedDot : event.status.toLowerCase() === "not approved" ? coordinatorStyle.notApprovedDot : event.status.toLowerCase() === "draft" ? coordinatorStyle.draftDot : event.status.toLowerCase() === "waiting for approval" ? coordinatorStyle.waitingDot : ""} mx-2`}></div>
                                  {event.status}
                                </h6>
                              </div>
                              <div className={`${coordinatorStyle.statusData} d-flex`}>
                                <div className="pe-3 w-50">
                                  <p className={`${coordinatorStyle.leftHeading} ${event.status.toLowerCase() === "waiting for approval" ? coordinatorStyle.waitingtextColor : ""
                                    }`}>
                                    Start and End Date
                                  </p>
                                </div>
                                <div className="w-50">
                                  <p className={`${coordinatorStyle.rightHeading} ${event.status.toLowerCase() === "waiting for approval" ? coordinatorStyle.waitingtextColor : ""
                                    }`}>
                                    {formatDate(event.event_start_date)} - {formatDate(event.event_end_date)}
                                  </p>
                                </div>
                              </div>
                              <div className={`${coordinatorStyle.statusData} d-flex`}>
                                <div className="pe-3 w-50">
                                  <p className={`${coordinatorStyle.leftHeading} ${event.status.toLowerCase() === "waiting for approval" ? coordinatorStyle.waitingtextColor : ""
                                    }`}>
                                    Start and End Time
                                  </p>
                                </div>
                                <div className="w-50">
                                  <p className={`${coordinatorStyle.rightHeading} ${event.status.toLowerCase() === "waiting for approval" ? coordinatorStyle.waitingtextColor : ""
                                    }`}>
                                    {/* {formatTime(event.event_start_time)} - {formatTime(event.event_end_time)} */}
                                    {event.event_start_time} - {event.event_end_time}
                                  </p>
                                </div>
                              </div>
                              <div className={`${coordinatorStyle.statusData} d-flex`}>
                                <div className="pe-3 w-50">
                                  <p className={`${coordinatorStyle.leftHeading} ${event.status.toLowerCase() === "approved" ? `` : event.status.toLowerCase() === "not approved" ? `` : event.status.toLowerCase() === "draft" ? `` : event.status.toLowerCase() === "waiting for approval" ? coordinatorStyle.waitingtextColor : ""}`}> Order books by: </p>
                                </div>
                                <div className="w-50">
                                  <p className={`${coordinatorStyle.rightHeading} ${event.status.toLowerCase() === "approved" ? `` : event.status.toLowerCase() === "not approved" ? `` : event.status.toLowerCase() === "draft" ? `` : event.status.toLowerCase() === "waiting for approval" ? coordinatorStyle.waitingtextColor : ""}`}> 00/00/0000 </p>
                                </div>
                              </div>
                              <div className={`${coordinatorStyle.statusData} d-flex`}>
                                <div className="pe-3 w-50">
                                  <p className={`${coordinatorStyle.leftHeading} ${event.status.toLowerCase() === "approved" ? `` : event.status.toLowerCase() === "not approved" ? `` : event.status.toLowerCase() === "draft" ? `` : event.status.toLowerCase() === "waiting for approval" ? coordinatorStyle.waitingtextColor : ""}`}> Authors: </p>
                                </div>
                                <div className="w-50">
                                  {event.books.map((book, index) => (
                                    <p key={index} className={`${coordinatorStyle.rightHeading} ${event.status.toLowerCase() === "approved" ? `` : event.status.toLowerCase() === "not approved" ? `` : event.status.toLowerCase() === "draft" ? `` : event.status.toLowerCase() === "waiting for approval" ? coordinatorStyle.waitingtextColor : ""}`}> {book.authorName} </p>
                                  ))}
                                </div>
                              </div>
                              <div className={`${coordinatorStyle.statusData} d-flex`}>
                                <div className="pe-3 w-50">
                                  <p className={`${coordinatorStyle.leftHeading} ${event.status.toLowerCase() === "approved" ? `` : event.status.toLowerCase() === "not approved" ? `` : event.status.toLowerCase() === "draft" ? `` : event.status.toLowerCase() === "waiting for approval" ? coordinatorStyle.waitingtextColor : ""}`}> Details: </p>
                                </div>
                                <div className={`w-50 ${coordinatorStyle.lineBreak}`}>
                                  <p className={`${coordinatorStyle.rightHeading} ${event.status.toLowerCase() === "approved" ? `` : event.status.toLowerCase() === "not approved" ? `` : event.status.toLowerCase() === "draft" ? `` : event.status.toLowerCase() === "waiting for approval" ? coordinatorStyle.waitingtextColor : ""}`}> Grade: {event.event_detail} </p>
                                  <p className={`${coordinatorStyle.rightHeading} ${event.status.toLowerCase() === "approved" ? `` : event.status.toLowerCase() === "not approved" ? `` : event.status.toLowerCase() === "draft" ? `` : event.status.toLowerCase() === "waiting for approval" ? coordinatorStyle.waitingtextColor : ""}`}> Location: {event.event_location} </p>
                                </div>
                              </div>
                              <div className={`${coordinatorStyle.bottomData} d-flex`}>
                                <div className="w-50 d-flex align-items-center justify-content-between pe-3">
                                  <p className={`${coordinatorStyle.leftEvent} pe-1`}> Share Event Page </p>
                                  <FaShareSquare className={`${coordinatorStyle.colorBlue} ${coordinatorStyle.shareIcon}`} />
                                </div>
                                <div className="w-50 d-flex align-items-center justify-content-between">
                                  <p className={coordinatorStyle.rightReport}> <strong> Inscription Report </strong> </p>
                                  <button className={`${coordinatorStyle.reportButton} btn btn-primary ms-2`}>
                                    <IoMdSearch />
                                  </button>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}